import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import PurchaseForm from "../components/PurchaseForm";

const EditPurchase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || "";

  // Use purchase from navigation state if available
  const purchaseFromState = location.state && location.state.purchase;

  const [initialValues, setInitialValues] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Always fetch purchase from API
        const purchaseRes = await fetch(`${API_URL}get-purchase.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ purchase_id: id }),
        });
        const purchaseData = await purchaseRes.json();
        if (purchaseData.status && purchaseData.data) {
          setInitialValues(purchaseData.data);
        }
        // Fetch suppliers and products
        const [supplierRes, productRes] = await Promise.all([
          fetch(`${API_URL}supplier-list.php`),
          fetch(`${API_URL}product-list.php`),
        ]);
        const supplierData = await supplierRes.json();
        const productData = await productRes.json();
        if (Array.isArray(supplierData.suppliers)) setSuppliers(supplierData.suppliers);
        if (productData.status && Array.isArray(productData.data)) setProducts(productData.data);
      } catch (error) {
        setToast({ show: true, message: "Failed to load data", type: "error" });
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [API_URL, id]);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}update_purchase.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (data.status === true) {
        setToast({ show: true, message: data.message || "Purchase updated!", type: "success" });
        setTimeout(() => navigate("/purchase-list"), 1500);
      } else {
        setToast({ show: true, message: data.message || "Failed to update purchase.", type: "error" });
      }
    } catch (error) {
      setToast({ show: true, message: "Network error. Please try again.", type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading || !initialValues || suppliers.length === 0 || products.length === 0) return <div>Loading...</div>;

  return (
    <div className="add-category-content">
      <div className="page-header" style={{ display: "block", textAlign: "left" }}>
        <h1>Edit Purchase</h1>
        <p>Update purchase details</p>
      </div>
      <div className="form-container" style={{ maxWidth: "90%" }}>
        <PurchaseForm
          mode="edit"
          initialValues={initialValues}
          onSubmit={handleSubmit}
          onCancel={() => navigate("/purchase-list")}
          suppliers={suppliers}
          products={products}
          isSubmitting={isSubmitting}
        />
      </div>
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditPurchase; 